export enum AclPermission {
  System = 'system',
  Admin = 'admin',
  Staff = 'staff',
  Project = 'project',
  Task = 'task',
  Environment = 'environment',
}
